<div class="errorMessage" *ngIf="isSubmitFailed">
  <div *ngIf="failContent?.status === 404 || failContent?.status === 400; else otherErrorMessage">
    <div>
      <span class="errorIcon"></span>
      <p>{{ failContent?.error.message }}</p>
    </div>
  </div>
  <ng-template #otherErrorMessage>
    <div>
      <span class="errorIcon"></span>
      <p>There was a problem adding the new user to your security set.</p>
    </div>
    <div>
      <span class="errorIcon"></span>
      <p>Try going back to the search page and adding the user again.</p>
    </div>
  </ng-template>
</div>
<form class="addUserForm" [formGroup]="userForm">
  <div class="addUserForm_form">
    <div class="addUserForm_form form-sections">
      <h2>Personal Information</h2>
      <div class="sectionInlineWrap">
        <div class="ods-form-field">
          <label for="firstName" id="firstNameLabel">First Name</label>
          <input
            [attr.aria-invalid]="(userForm.get('firstName').touched || submitted) && !userForm.get('firstName').valid"
            aria-required="true"
            aria-errormessage="firstName-error"
            class="ods-text-input"
            formControlName="firstName"
            id="firstName"
            type="text"
            autocomplete="off"
            maxlength="50"
          />
          <div aria-live="polite">
            <div
              id="firstName-error"
              class="errorWrap"
              *ngIf="(userForm.get('firstName').touched || submitted) && !userForm.get('firstName').valid"
            >
              <span class="errorIcon"></span>
              <p *ngIf="userForm.get('firstName').errors?.required">Enter the user’s first name</p>
              <p *ngIf="userForm.get('firstName').errors?.pattern">Enter a valid first name</p>
            </div>
          </div>
        </div>
        <div class="ods-form-field">
          <label for="mi" id="miLabel">MI <span class="optionalFont">(Optional)</span></label>
          <input
            class="ods-text-input"
            formControlName="mi"
            id="mi"
            type="text"
            autocomplete="off"
            maxlength="1"
            pattern="[A-Za-z]{1}"
          />
          <div class="errorWrap" *ngIf="!userForm.get('mi').valid && userForm.get('mi').touched">
            <span class="errorIcon"></span>
            <p *ngIf="userForm.get('mi').errors?.pattern">Enter a valid middle initial</p>
          </div>
        </div>
      </div>
      <div class="ods-form-field">
        <label for="lastName" id="lastNameLabel">Last Name</label>
        <input
          [attr.aria-invalid]="(userForm.get('lastName').touched || submitted) && !userForm.get('lastName').valid"
          aria-required="true"
          aria-errormessage="lastName-error"
          class="ods-text-input"
          formControlName="lastName"
          id="lastName"
          type="text"
          autocomplete="off"
          maxlength="50"
        />
        <div aria-live="polite">
          <div
            id="lastName-error"
            class="errorWrap"
            *ngIf="(userForm.get('lastName').touched || submitted) && !userForm.get('lastName').valid"
          >
            <span class="errorIcon"></span>
            <p *ngIf="userForm.get('lastName').errors?.required">Enter the user’s last name</p>
            <p *ngIf="userForm.get('lastName').errors?.pattern">Enter a valid last name</p>
          </div>
        </div>
      </div>
    </div>
    <div class="addUserForm_form form-sections">
      <h2>Physician Information</h2>
      <div>
        <fieldset class="ods-form-field">
          <legend for="physician" class="physicianLabel" id="physicianLabel">
            {{ isUserProfileForm ? 'Are you ' : 'Is this user' }} a physician? (MD or DO)
          </legend>
          <div class="radioInputWrap">
            <input
              [attr.aria-invalid]="(userForm.get('physician').touched || submitted) && !userForm.get('physician').valid"
              aria-required="true"
              aria-errormessage="physician-error"
              class="ods-radio-input"
              formControlName="physician"
              id="isPhysicianYesRadio"
              type="radio"
              value="Y"
            />
            <label for="isPhysicianYesRadio"> Yes</label>
          </div>
          <div>
            <input
              [attr.aria-invalid]="(userForm.get('physician').touched || submitted) && !userForm.get('physician').valid"
              aria-required="true"
              aria-errormessage="physician-error"
              class="ods-radio-input"
              formControlName="physician"
              id="isPhysicianNoRadio"
              type="radio"
              value="N"
            />
            <label for="isPhysicianNoRadio"> No</label>
          </div>
          <div aria-live="polite">
            <div
              id="physician-error"
              class="errorWrap"
              *ngIf="(userForm.get('physician').touched || submitted) && !userForm.get('physician').valid"
            >
              <span class="errorIcon"></span>
              <p *ngIf="userForm.get('physician').errors?.required">Select option. Is the user a physician?</p>
            </div>
          </div>
        </fieldset>
        <div class="ods-form-field" *ngIf="isPhysician">
          <label for="npi" id="npiLabel">NPI</label>
          <input
            [attr.aria-invalid]="
              (userForm.get('npi').touched || submitted) && !userForm.get('npi').valid && isPhysician
            "
            aria-required="true"
            aria-errormessage="npi-error"
            aria-label="npi"
            class="ods-text-input"
            formControlName="npi"
            id="npi"
            type="text"
            autocomplete="off"
            placeholder="Up to 10 characters"
            maxlength="10"
            pattern="[0-9]{10}"
          />
          <div aria-live="polite">
            <div
              id="npi-error"
              class="errorWrap"
              *ngIf="(userForm.get('npi').touched || submitted) && !userForm.get('npi').valid && isPhysician"
            >
              <span class="errorIcon"></span>
              <p *ngIf="userForm.get('npi').errors?.required || userForm.get('npi').errors?.pattern">
                Enter a valid NPI
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="addUserForm_form form-sections">
      <h2>Contact Information</h2>
      <div class="ods-form-field">
        <label for="email" id="emailLabel">Email</label>
        <input
          [attr.aria-invalid]="(userForm.get('email').touched || submitted) && !userForm.get('email').valid"
          aria-required="true"
          aria-errormessage="email-error"
          class="ods-text-input"
          formControlName="email"
          id="email"
          type="email"
          maxlength="100"
          autocomplete="off"
        />
        <div aria-live="polite">
          <div
            id="email-error"
            class="errorWrap"
            *ngIf="(userForm.get('email').touched || submitted) && !userForm.get('email').valid"
          >
            <span class="errorIcon"></span>
            <p *ngIf="userForm.get('email').errors?.required || userForm.get('email').errors?.email">
              Enter a valid email address
            </p>
          </div>
        </div>
      </div>
      <div class="sectionInlineWrap">
        <div class="ods-form-field phone-number">
          <label for="phone" id="phoneLabel">Work Phone</label>
          <input
            [attr.aria-invalid]="(userForm.get('phone').touched || submitted) && !userForm.get('phone').valid"
            aria-required="true"
            aria-errormessage="phone-error"
            class="ods-text-input"
            formControlName="phone"
            id="phone"
            type="text"
            autocomplete="off"
            maskPhoneNumber
            maxlength="14"
            pattern="\(?[0-9]{3}\)?[\s]?[0-9]{3}[\-]?[0-9]{4}"
            inputNumeric
          />
          <div aria-live="polite">
            <div
              id="phone-error"
              class="errorWrap"
              *ngIf="(userForm.get('phone').touched || submitted) && !userForm.get('phone').valid"
            >
              <span class="errorIcon"></span>
              <p *ngIf="userForm.get('phone').errors?.required || userForm.get('phone').errors?.pattern">
                Enter a valid phone number
              </p>
            </div>
          </div>
        </div>
        <div class="ods-form-field">
          <label for="phoneExt" id="phoneExtLabel">Ext <span class="optionalFont">(Optional)</span></label>
          <input
            class="ods-text-input"
            formControlName="phoneExt"
            id="phoneExt"
            type="text"
            autocomplete="off"
            maxlength="3"
            pattern="[0-9]{1,3}"
            inputNumeric
          />
          <div
            id="phoneExt-error"
            class="errorWrap"
            *ngIf="userForm.get('phoneExt').touched && !userForm.get('phoneExt').valid"
          >
            <span class="errorIcon"></span>
            <p *ngIf="userForm.get('phoneExt').errors?.pattern">Enter a valid phone extension</p>
          </div>
        </div>
      </div>
    </div>
    <div class="addUserForm_form form-sections">
      <h2>Office Address</h2>
      <div class="ods-form-field">
        <label for="address1" id="address1Label">Street Address</label>
        <input
          [attr.aria-invalid]="(userForm.get('address1').touched || submitted) && !userForm.get('address1').valid"
          aria-required="true"
          aria-errormessage="address1-error"
          class="ods-text-input"
          formControlName="address1"
          id="address1"
          autocomplete="off"
          maxlength="50"
        />
        <div aria-live="polite">
          <div
            id="address1-error"
            class="errorWrap"
            *ngIf="(userForm.get('address1').touched || submitted) && !userForm.get('address1').valid"
          >
            <span class="errorIcon"></span>
            <p *ngIf="userForm.get('address1').errors?.required">Enter the street address</p>
            <p *ngIf="userForm.get('address1').errors?.pattern">Enter a valid street address</p>
          </div>
        </div>
      </div>
      <div class="ods-form-field">
        <label for="address2" id="address2Label">Address Line 2 <span class="optionalFont">(Optional)</span></label>
        <input class="ods-text-input" formControlName="address2" id="address2" autocomplete="off" maxlength="50" />
      </div>
      <div class="sectionInlineWrap">
        <div class="ods-form-field">
          <label for="city" id="cityLabel">City</label>
          <input
            [attr.aria-invalid]="(userForm.get('city').touched || submitted) && !userForm.get('city').valid"
            aria-required="true"
            aria-errormessage="city-error"
            class="ods-text-input"
            formControlName="city"
            id="city"
            autocomplete="off"
            maxlength="50"
          />
          <div aria-live="polite">
            <div
              id="city-error"
              class="errorWrap"
              *ngIf="(userForm.get('city').touched || submitted) && !userForm.get('city').valid"
            >
              <span class="errorIcon"></span>
              <p *ngIf="userForm.get('city').errors?.required">Enter the city</p>
              <p *ngIf="userForm.get('city').errors?.pattern">Enter a valid city</p>
            </div>
          </div>
        </div>
        <div class="ods-form-field">
          <label for="state" id="stateLabel">State</label>
          <ods-select odsFormControl aria-label="state" formControlName="state" placeholder="--" id="state">
            <ods-select-option *ngFor="let state of stateOptions" [value]="state.value">
              {{ state.label }}
            </ods-select-option>
          </ods-select>
          <div aria-live="polite">
            <div
              id="state-error"
              class="errorWrap"
              *ngIf="(userForm.get('state').touched || submitted) && !userForm.get('state').valid"
            >
              <span class="errorIcon"></span>
              <p *ngIf="userForm.get('state').errors?.required">Select a state</p>
            </div>
          </div>
        </div>
        <div class="ods-form-field">
          <label for="zipcode" id="zipcodeLabel">ZIP</label>
          <input
            [attr.aria-invalid]="(userForm.get('zipcode').touched || submitted) && !userForm.get('zipcode').valid"
            aria-required="true"
            aria-errormessage="zipcode-error"
            class="ods-text-input"
            formControlName="zipcode"
            id="zipcode"
            autocomplete="off"
            maxlength="5"
            pattern="[0-9]{5}"
            inputNumeric
          />
          <div aria-live="polite">
            <div
              id="zipcode-error"
              class="errorWrap"
              *ngIf="(userForm.get('zipcode').touched || submitted) && !userForm.get('zipcode').valid"
            >
              <span class="errorIcon"></span>
              <p *ngIf="userForm.get('zipcode').errors?.required || userForm.get('zipcode').errors?.pattern">
                Enter a valid ZIP code
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="addUserForm_form form-sections" *ngIf="!addnewUserIdFlag || isEditOn || isAddUserEditOn || isUserProfileForm">
      <h2>Sign In Information</h2>
      <div>
        <div class="ods-form-field">
          <div class="wrapUserIdLabel">
            <span>
              <label for="userId" id="userIdLabel">User ID</label>
            </span>
            <span>
              <div *ngIf="!isEditOn && !isAddUserEditOn && !isUserProfileForm">
                <app-tooltip [position]="'top'">
                  <div>maximum of 10 characters,</div>
                  <div>letters and numbers are allowed, </div>
                  <div>special characters are not permitted</div>
                </app-tooltip>
              </div>
            </span>
          </div>
          <div class="userid-search-wrapper">
            @if(isEditOn || isAddUserEditOn || isUserProfileForm) {
              <input
                [attr.aria-invalid]="(userForm.get('userId').touched || submitted) && !userForm.get('userId').valid"
                aria-required="true"
                aria-errormessage="userId-error"
                class="ods-text-input userId"
                formControlName="userId"
                id="userId"
                autocomplete="off"
                [ngClass]="{ disabledUserId: isEditOn || isAddUserEditOn || isUserProfileForm}"
                [tabIndex]="isEditOn || isAddUserEditOn || isUserProfileForm ? -1 : 0"
              />
            } @else {
              <input
                [attr.aria-invalid]="(userForm.get('userId').touched || submitted) && !userForm.get('userId').valid"
                aria-required="true"
                aria-errormessage="userId-error"
                class="ods-text-input userId"
                formControlName="userId"
                id="userId"
                autocomplete="off"
                placeholder="Up to 10 characters"
                maxlength="10"
                minlength="1"
                pattern="[A-Za-z0-9]{1,10}"
                [ngClass]="{ disabledUserId: isEditOn || isAddUserEditOn || isUserProfileForm}"
                [tabIndex]="isEditOn || isAddUserEditOn || isUserProfileForm ? -1 : 0"
              />
            }

          <div class="loader-spinner" *ngIf="isloading"><div></div><div></div><div></div><div></div></div>
         </div>
          <div aria-live="polite">
            <div
              id="userId-error"
              class="errorWrap"
              *ngIf="((userForm.get('userId').touched || submitted) && !userForm.get('userId').valid) || isExistingUser"
            >
              <span class="errorIcon"></span>
              <p *ngIf="userForm.get('userId').errors?.required || userForm.get('userId').errors?.pattern">
                Enter a valid user ID
              </p>
              <p *ngIf="userForm.get('userId').errors === null && isExistingUser">User ID already exists</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <footer class="addUserForm_footer">
    <!-- TODO: Should the buttons be active if error occured while submitting form? -->
    <ods-button
      id="submitBtn"
      [loading]="isSubmitLoading"
      [disabled]="isloading || isSubmitFailed"
      (click)="submitAddUser()"
    >
      <ng-container *ngIf="!isEditOn && !userInfoFromParent">Add User</ng-container>
      <ng-container *ngIf="isEditOn || userInfoFromParent">Edit User</ng-container>
    </ods-button>
    <ods-button id="cancelBtn" variant="ghost" (click)="cancel()">Cancel</ods-button>
  </footer>
</form>
